import { breakSettings, refreshSlider } from "@grindex-client/components/Slider/slider";
import { addListener, getNextSibling, hideElement, showElement, getPreviousSibling, isVisible } from "@grindex-common/helpers/domManipulation";
import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { videoRenderer } from "@grindex-common/helpers/videoRenderer";
import { XylemCookies } from "@grindex-common/helpers/XylemCookies.class";
import { adjustFixedHeader } from "@grindex-common/helpers/header";
import SinglePagePromotionDom from "./singlePagePromotion.dom";

function init($views) {
	const $module = $views[0];

	const SELECTOR_IN_VIEW_FADEINSLOW = ".in-view[data-transition-fadeInSlow]";
	const SELECTOR_FIRST_IN_VIEW_SCALEUP = ".js-animation-first.in-view[data-transition-scaleUpFrom60]";
	const SELECTOR_IN_VIEW_SCALEUP_IMG = ".in-view[data-transition-scaleUpFrom60-parent] img";
	const SELECTOR_FIRST_IN_VIEW_FADEINSLOW = ".js-animation-first.in-view[data-transition-fadeInSlow]";
	const SELECTOR_SECOND_IN_VIEW_FADEINSLOW = ".js-animation-second.in-view[data-transition-fadeInSlow]";
	const SELECTOR_THIRD_IN_VIEW_FADEINSLOW = ".js-animation-third.in-view[data-transition-fadeInSlow]";

	const CLASS_TRANSITION = "transition";
	const CLASS_FADEIN_SLOW = "transition--fadeInSlow";
	const CLASS_SCALEUP_FROM_60_FAST = "transition--scaleUpFrom60Fast";
	const CLASS_SCALEUP_FROM_60 = "transition--scaleUpFrom60";

	const SHOWANIMATIONSCOOKIE = "xyl-showAnimations";
	const SCROLLVALUE = 60;

	const dom = new SinglePagePromotionDom($module);
	const xylemCookies = new XylemCookies();
	const resolution = new Resolution();

	const timeoutMap = [
		getTimeoutObject(SELECTOR_IN_VIEW_SCALEUP_IMG, [CLASS_TRANSITION, CLASS_SCALEUP_FROM_60_FAST], 200),
		getTimeoutObject(SELECTOR_FIRST_IN_VIEW_FADEINSLOW, [CLASS_TRANSITION, CLASS_FADEIN_SLOW], 500),
		getTimeoutObject(SELECTOR_SECOND_IN_VIEW_FADEINSLOW, [CLASS_TRANSITION, CLASS_FADEIN_SLOW], 1000),
		getTimeoutObject(SELECTOR_THIRD_IN_VIEW_FADEINSLOW, [CLASS_TRANSITION, CLASS_FADEIN_SLOW], 1500),
		getTimeoutObject(SELECTOR_THIRD_IN_VIEW_FADEINSLOW, [CLASS_TRANSITION, CLASS_FADEIN_SLOW], 1500),
	];

	const initCardCarousel = () => {
		const $sliders = document.querySelectorAll(".cardSlider:not(.social)");

		$sliders.forEach(($slider) => {
			$($slider).bxSlider({
				slideWidth: 208,
				minSlides: 1,
				maxSlides: 4,
				breaks: breakSettings.smallCardBreakSettings,
				pager: false,
				slideMargin: 23,
				pause: 5000,
				autoReload: false,
				useCSS: false,
				onSliderRedraw() {
					refreshSlider($slider);
				},
			});
		});
	};

	function AddClassIfAnimationsInView() {
		dom.getAnimationElements().forEach(($element) => {
			if (isVisible($element)) {
				dom.setAnimationInView($element);
			} else {
				dom.setAnimationNotInView($element);
			}
		});
	}

	function getTimeoutObject(selector, classes, timeout) {
		return {
			selector: selector,
			classes: classes,
			timeout: timeout,
		};
	}

	function showTransition() {
		document.querySelectorAll(SELECTOR_IN_VIEW_FADEINSLOW).forEach(($element) => {
			$element.classList.add(CLASS_TRANSITION, CLASS_FADEIN_SLOW);
		});

		document.querySelectorAll(SELECTOR_FIRST_IN_VIEW_SCALEUP).forEach(($element) => {
			$element.classList.add(CLASS_TRANSITION, CLASS_SCALEUP_FROM_60);
		});

		timeoutMap.map((timeoutObject) => {
			var timeout = setTimeout(() => {
				document.querySelectorAll(timeoutObject.selector).forEach(($element) => {
					$element.classList.add(timeoutObject.classes);
				});
				clearTimeout(timeout);
			}, timeoutObject.timeout);
		});

		if (dom.getAnimationElements().length === dom.getInViewElements().length) {
			this.setSessionCookie(SHOWANIMATIONSCOOKIE, false);
		}
	}

	function transitionEvents() {
		window.addEventListener("resize", AddClassIfAnimationsInView);
		window.addEventListener("scroll", AddClassIfAnimationsInView);

		if (dom.getBounceInImages()) {
			dom.getBounceInImages().forEach(($image) => {
				dom.activateBounceIn($image);
			});
		}

		window.addEventListener(
			"scroll",
			function () {
				showTransition();
			}.bind(this),
		);
	}

	function noTransition() {
		dom.disableTransitions();
	}

	function checkCookieTransition() {
		const cookieValue = xylemCookies.getCookieValue(SHOWANIMATIONSCOOKIE);
		if (!cookieValue) {
			transitionEvents();
		} else {
			noTransition();
		}
	}

	function renderVideo($videoImage) {
		if (!$videoImage) {
			return;
		}

		const dataKey = $videoImage.dataset.key;
		const videoPlayerId = $videoImage.dataset.videoPlayerId;
		const $imageContainer = $videoImage.parentElement;
		const $existingVideo = dom.getExistingVideo(dataKey, videoPlayerId);

		hideElement($imageContainer);

		if ($existingVideo) {
			const $existingImage = getNextSibling($existingVideo.parentElement, "div");
			showElement($existingImage);
			$existingVideo.remove();
		}

		if (dataKey) {
			videoRenderer.renderOverlayVideo(dataKey, videoPlayerId, getPreviousSibling($imageContainer, "div"));
		}
	}

	function playIconEvent(e) {
		const $currentSiblings = getPreviousSibling(e.target, "img");

		renderVideo($currentSiblings);
	}

	function thumbEvent(e) {
		renderVideo(e.target);
	}

	function initOptions() {
		adjustFixedHeader({
			scrollValue: SCROLLVALUE,
			adjustSelector: "fixed-header",
		});
	}

	function createEventListeners() {
		if (dom.getMobileThumb()) {
			dom.getMobileThumb().addEventListener("click", function (e) {
				thumbEvent(e);
			});
		}

		if (dom.getDesktopThumb()) {
			dom.getDesktopThumb().addEventListener("click", function (e) {
				thumbEvent(e);
			});
		}

		if (dom.getPlayIcons()) {
			dom.getPlayIcons().forEach(($icon) => {
				$icon.addEventListener("click", function (e) {
					playIconEvent(e);
				});
			});
		}

		if (dom.getIngreesIcon()) {
			dom.getIngreesIcon().addEventListener("click", function (e) {
				playIconEvent(e);
			});
		}

		checkCookieTransition();

		initOptions();

		addListener(dom.getFloatingButton(), "click", () => {
			const primaryColor = dom.getModalPrimaryColor();

			const secondaryColor = dom.getModalSecondaryColor();

			if (primaryColor && secondaryColor) {
				dom.setModalMarketoButtonGradient(primaryColor, secondaryColor);
			}

			dom.hideBodyOverflow();

			dom.getModal().open();
		});

		if (resolution.isLargerThan(resolution.desktop)) {
			renderVideo(dom.getDesktopThumb());
		} else if (dom.getMobileThumb()) {
			renderVideo(dom.getMobileThumb());
		}

		if (window.config.singlePagePromotion.isPageInEditMode === "True") {
			window.addEventListener("load", function () {
				parent.document.body.querySelector("iframe").parentElement.addEventListener("scroll", function () {
					globals.scrollAnimations.AddClassIfAnimationsInView();
					showTransition();
				});
			});
		}

		if (window.location.hash) {
			window.addEventListener("load", function () {
				const $element = dom.getElementToScroll(window.location.hash);
				if ($element) {
					$element.scrollIntoView(true);
				}
			});
		}
	}

	createEventListeners();

	initCardCarousel();
}

export default {
	view: "singlePagePromotion",
	init,
};
